// extracted by mini-css-extract-plugin
export default {"root":"QrV93H","iframe":"GALQU4"};